export const InstagramIcon = ({
  width = 24,
  height = 24,
  title = "Instagram",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}>
      <title>{title}</title>
      <path
        fill="#F5F6F7"
        d="M12 6.502a5.486 5.486 0 0 0-5.494 5.494A5.486 5.486 0 0 0 12 17.49a5.486 5.486 0 0 0 5.494-5.494A5.486 5.486 0 0 0 12 6.502m0 9.065a3.58 3.58 0 0 1-3.57-3.57A3.58 3.58 0 0 1 12 8.425a3.58 3.58 0 0 1 3.57 3.57 3.58 3.58 0 0 1-3.57 3.57m5.718-10.57c-.71 0-1.282.573-1.282 1.283s.573 1.283 1.282 1.283a1.28 1.28 0 0 0 1.186-1.774 1.28 1.28 0 0 0-1.186-.792m4.99 7c0-1.48.014-2.945-.069-4.42-.083-1.715-.474-3.236-1.728-4.49-1.256-1.256-2.775-1.644-4.489-1.728-1.479-.083-2.944-.07-4.42-.07-1.478 0-2.943-.013-4.42.07-1.713.084-3.235.475-4.488 1.728-1.257 1.256-1.645 2.775-1.728 4.49-.083 1.478-.07 2.943-.07 4.42 0 1.475-.013 2.943.07 4.419.083 1.714.474 3.235 1.728 4.489 1.256 1.256 2.775 1.645 4.489 1.728 1.478.083 2.944.07 4.42.07 1.478 0 2.943.013 4.42-.07 1.713-.083 3.235-.474 4.488-1.728 1.257-1.256 1.645-2.775 1.728-4.49.086-1.475.07-2.94.07-4.419m-2.356 6.315a3.4 3.4 0 0 1-.81 1.227c-.377.378-.739.613-1.226.809-1.41.56-4.755.434-6.316.434-1.562 0-4.91.126-6.319-.431a3.4 3.4 0 0 1-1.227-.81 3.4 3.4 0 0 1-.809-1.226c-.557-1.412-.43-4.757-.43-6.319s-.127-4.91.43-6.319c.196-.487.432-.851.81-1.226.377-.375.739-.614 1.226-.81 1.409-.557 4.757-.43 6.319-.43 1.561 0 4.91-.127 6.319.43.487.196.851.432 1.226.81.378.377.614.739.81 1.226.556 1.41.43 4.758.43 6.32 0 1.56.126 4.906-.433 6.315"></path>
    </svg>
  );
};
